export const MAXIMUM_TIMESPAN = { months: 6 };
